import { useEffect, useState } from 'react'
import axios from 'axios'
import { useLanguage } from '../context/LangaugeContextProvider/LangaugeContextProvider'
import { BASE_URL, DEFAULT_PARAM } from '../Contansts'

// const BASE_URL = process.env.REACT_APP_BASE_URL + '/api'
// const DEFAULT_PARAM = 'populate=deep'

function useFetch(path, transferData, query = '', count) {
  const { language } = useLanguage()

  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (language?.code) {
      const url = `${BASE_URL}/${path}?${DEFAULT_PARAM}&locale=${language?.code || ''}${query !== '' ? '&' + query : ''}`
      setLoading(true)
      setError(null)
      axios
        .get(url, {
          headers: {
            'Content-Type': 'application/json',
          },
        })
        .then((res) => {
          setData(transferData ? transferData(res.data) : res.data)
          setLoading(false)
        })
        .catch((err) => {
          setError({
            errorMessage:
              err?.response?.data?.error?.message || 'Something went wrong',
            hasError: true,
          })
          setLoading(false)
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, query, language?.code, count])

  return { data, loading, error }
}

export default useFetch
